// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkArrowRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
            <path
                fill="currentColor"
                d="M13.7062001,6.70703125 L8.70620012,11.7070313 C8.51244974,11.9039059 8.25620031,12.0007811 7.99994993,12.0007811 C7.74369955,12.0007811 7.48807478,11.9031248 7.29307508,11.7078123 C6.90245008,11.3171873 6.90245008,10.6843748 7.29307508,10.2937498 L10.5874496,7.00078106 L0.999949932,7.00078106 C0.447762489,7.00078106 0,6.55390644 0,6.00078106 C0,5.44765568 0.447762489,5.00078106 0.999949932,5.00078106 L10.5874496,5.00078106 L7.29369974,1.70703125 C6.90307474,1.31640625 6.90307474,0.68359375 7.29369974,0.29296875 C7.68432474,-0.09765625 8.31713724,-0.09765625 8.70776224,0.29296875 L13.7077622,5.29296875 C14.0968251,5.68515587 14.0968251,6.31640625 13.7062001,6.70703125 Z"
            />
        </svg>
    );
};

export default React.memo(LinkArrowRight);
